var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightWhite = function SvgArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.162,
    height: 5.121,
    viewBox: "0 0 3.162 5.121"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.162 10.019L9.208 8.06l1.954-1.96-.6-.6L8 8.06l2.56 2.56z",
    transform: "rotate(-180 5.581 5.31)"
  })));
};
export { SvgArrowRightWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzLjE2MiIgaGVpZ2h0PSI1LjEyMSIgdmlld0JveD0iMCAwIDMuMTYyIDUuMTIxIj4KICAgIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xMS4xNjIgMTAuMDE5TDkuMjA4IDguMDZsMS45NTQtMS45Ni0uNi0uNkw4IDguMDZsMi41NiAyLjU2eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCA1LjU4MSA1LjMxKSIvPgo8L3N2Zz4K";